import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomerService} from '../../../../core/services/customer.service';
import {CustomValidators} from '../../../validator/customValidators';
import {Company, CompanyList} from '../../../model/company.model';
import {SearchForCompanyComponent} from '../../../search-for-company/search-for-company.component';
import {DialogOpener} from '../../../utils/dialog-opener';
import {INewCompany} from '../../../model/interface/new-company.model.interface';
import {filter, map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AddressType} from 'src/app/shared/model/interface/address-type.model.interface';

@Component({
  selector: 'app-new-company',
  templateUrl: './new-company.component.html',
  styleUrls: ['./new-company.component.css']
})
export class NewCompanyComponent implements OnInit {
  @Input() company: Company;
  @Output() existingCompany = new EventEmitter<Company>();
  companyForm: FormGroup;
  filteredCompanies: Observable<Company[]>;
  AddressType = AddressType;

  private existingCompanies: Company[];

  constructor(private customerService: CustomerService,
              private formBuilder: FormBuilder,
              private dialogOpener: DialogOpener) {
    this.createForm();
  }

  ngOnInit() {
    this.fetchCompanies();
    this.searchForExistingCompany();
  }

  fetchCompanies() {
    this.customerService.getAllCompanies()
      .subscribe((companies: CompanyList) => this.existingCompanies = companies.data);
  }

  private createForm() {
    this.companyForm = this.formBuilder.group({
      companyName: [null, [Validators.required]],
      nip: [null, CustomValidators.NIPValidator],
      regon: [null, CustomValidators.REGONValidator],
      mainAddress: [null, Validators.required],
      correspondenceAddress: [null],
      individualNumber: [null]
    });
  }

  findInGus() {
    const dialogRef = this.dialogOpener.getNonNullDialogResponseObservable(SearchForCompanyComponent);
    return dialogRef
      .subscribe((company: any) => {
        this.companyForm.patchValue({
          companyName: company.companyName,
          nip: company.nip,
          regon: company.regon,
          mainAddress: company.mainAddress
        });
      });
  }

  private searchForExistingCompany() {
    this.filteredCompanies = this.companyForm
      .controls
      .nip
      .valueChanges
      .pipe(
        startWith(''),
        filter(value => value),
        map(value => {
          return this.existingCompanies.filter(company => company.nip?.startsWith(value));
        }),
      );
  }

  chooseCompany(company: Company) {
    this.existingCompany.emit(company);
  }
}
